const fixFormat = Intl.NumberFormat('es-US')
const columns = [
  {
    Header: "Fecha",
    accessor: "dateFormated",
    filterable: true,
    filterMethod: (filter, row) =>
      row.dateFormated.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Exitencia Inicial",
    accessor: "initial_existence.total",
    filterable: true,
    Cell: props => props.value != null ? `${fixFormat.format(props.value.toFixed(2))}` : null,
    filterMethod: (filter, row) =>
      String(row["initial_existence.total"]).includes(filter.value.toLowerCase()),
  },
  {
    Header: "Entrada Embarques",
    accessor: "shipmentsEntry.total",
    filterable: true,
    Cell: props => props.value != null ? `${fixFormat.format(props.value.toFixed(2))}` : null,
    filterMethod: (filter, row) =>
      String(row["shipmentsEntry.total"]).toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Entrada 20 Cº Embarques",
    accessor: "shipmentsEntry.total20c",
    filterable: true,
    Cell: props => props.value != null ? `${fixFormat.format(props.value.toFixed(2))}` : null,
    filterMethod: (filter, row) =>
      String(row["shipmentsEntry.total20c"]).toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Salida Anden",
    accessor: "platformDischarge.total",
    filterable: true,
    Cell: props => props.value != null ? `${fixFormat.format(props.value.toFixed(2))}` : null,
    filterMethod: (filter, row) =>
      String(row["platformDischarge.total"]).toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Salida 20Cº Anden",
    accessor: "platformDischarge.total20c",
    filterable: true,
    Cell: props => props.value != null ? `${fixFormat.format(props.value.toFixed(2))}` : null,
    filterMethod: (filter, row) =>
      String(row["platformDischarge.total20c"]).toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Salida Autotanque",
    accessor: "autotankDischarge.total",
    filterable: true,
    Cell: props => props.value != null ? `${fixFormat.format(props.value.toFixed(2))}` : null,
    filterMethod: (filter, row) =>
      String(row["autotankDischarge.total"]).toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Salida 20Cº Autotanque",
    accessor: "autotankDischarge.total20c",
    filterable: true,
    Cell: props => props.value != null ? `${fixFormat.format(props.value.toFixed(2))}` : null,
    filterMethod: (filter, row) =>
      String(row["autotankDischarge.total20c"]).toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Salida Carburación",
    accessor: "carburetorDischarge.total",
    filterable: true,
    Cell: props => props.value != null ? `${fixFormat.format(props.value.toFixed(2))}` : null,
    filterMethod: (filter, row) =>
      String(row["carburetorDischarge.total"]).toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Salida 20Cº Carburación",
    accessor: "carburetorDischarge.total20c",
    filterable: true,
    Cell: props => props.value != null ? `${fixFormat.format(props.value.toFixed(2))}` : null,
    filterMethod: (filter, row) =>
      String(row["carburetorDischarge.total20c"]).toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Exitencia Final",
    accessor: "finalExistence",
    filterable: true,
    Cell: props => props.value != null ? `${fixFormat.format(props.value.toFixed(2))}` : null,
    filterMethod: (filter, row) =>
      String(row.finalExistence).toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Exitencia Final 20Cº",
    accessor: "finalExistence20c",
    filterable: true,
    Cell: props => props.value != null ? `${fixFormat.format(props.value.toFixed(2))}` : null,
    filterMethod: (filter, row) =>
      String(row.finalExistence20c).toLowerCase().includes(filter.value.toLowerCase()),
  },
];

export { columns };
